import Box from "/app/src/components/generic/components/box";
import HeroDivider from "/app/src/components/HeroUi/Divider";
import PrimaryMapping from "./primaryMapping";
import { Integration } from "/app/src/models";
import { Mappings } from "/app/src/components/generic/components/apps/data/mappings";

/**
 *
 * @param param0 integration
 * @returns DataMappings component
 */
export default function DataMappings({
  integration,
}: {
  integration: Integration;
}) {
  return (
    <Box>
      <PrimaryMapping integration={integration} />
      <HeroDivider className="my-3" />
      <Mappings box={false} integration={integration} />
    </Box>
  );
}
